<template>
  <div :key="riskAnalysis.id">
    <router-view />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
    computed: {
        ...mapGetters([
            'riskAnalysis',
        ]),
    },
    async beforeRouteUpdate(to, from, next) {
        if (from.params.riskAnalysisId !== to.params.riskAnalysisId) {
            if (await this.getRiskAnalyisInfo(to.params.riskAnalysisId)) {
                next();
            }
        } else {
            next();
        }
    },
    methods: {
        ...mapActions({
            getRiskAnalyisInfo: 'getRiskAnalyisInfo',
        }),
    },
};
</script>
